import React, { useState, useEffect } from 'react';
import { CloseIcon } from '@images/svg';
import { useRouter } from 'next/router';

import { Router, withTranslation } from '@i18n';
import { OPINION_MAIN_FLOW, TREATMENT_COST_FLOW } from '@routes';
import { useBreakpoint } from '@lib/hooks/useBreakpoint';
import CampaignForm from './CampaignForm/index';

import {
  Backdrop,
  BannerContainer,
  BannerCard,
  BannerContent,
  ImageContainer,
  ImageOverlay,
  ImageText,
  ContentContainer,
  TextContentHeading,
  TextContentSubHeading,
  FormContainer,
  RedirectContainer,
  RedirectButton,
  StyledDiv
} from './styles';

const PopupBanner = ({ t, campaign }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [modalSlide, setModalSlide] = React.useState(0);
  const isMobile = useBreakpoint('mobile', 'desktop');
  const consturl = window.location.pathname;
  const router = useRouter();
  useEffect(() => {
    setModalSlide(0);
    const shouldShowBasedOnFrequency = checkDisplayFrequency(campaign);
    if (shouldShowBasedOnFrequency) {
      markCampaignAsShown(campaign);
    }
  }, [router.asPath]);


  function checkDisplayFrequency(campaign) {
    const campaignId = campaign?.id.toString();

    switch (campaign?.show_frequency) {
      case 'always':
        return true;

      case 'once_per_session':
      {
        const sessionKey = `campaign_shown_session_${campaignId}`;
        return !sessionStorage.getItem(sessionKey);
      }

      case 'once_per_user':
      {
        const userKey = `campaign_shown_user_${campaignId}`;
        return !localStorage.getItem(userKey);
      }

      default:
        return true;
    }
  }

  function markCampaignAsShown(campaign) {
    const campaignId = campaign?.id.toString();
    switch (campaign?.show_frequency) {
      case 'once_per_session':
      {
        const sessionKey = `campaign_shown_session_${campaignId}`;
        sessionStorage.setItem(sessionKey, 'true');
        break;
      }

      case 'once_per_user':
      {
        const userKey = `campaign_shown_user_${campaignId}`;
        localStorage.setItem(userKey, 'true');
        break;
      }

      // No storage needed for 'always'
      default:
        break;
    }
  }

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleRedirect = (pathname) => {
    if (pathname === 'secondOpinion') {
      Router.pushRoute(OPINION_MAIN_FLOW, { path: 'name' });
    } else {
      Router.pushRoute(TREATMENT_COST_FLOW, { path: 'name' });
    }
  };

  if (!campaign || !isVisible) return null;

  return (
    <>
      <Backdrop isVisible={isVisible} onClick={handleClose} />
      <BannerContainer>
        <BannerContent form={campaign.form_type}>
          <ImageContainer form={campaign.form_type}>
            {isMobile
            && (
              <BannerCard $isVisible={isVisible} onClick={handleClose}>
                <CloseIcon />
              </BannerCard>
            )}
            <img
              src={campaign.cover_image.url}
              alt={campaign.image_title}
            />
            <ImageOverlay />
            <ImageText>{campaign.offer_text}</ImageText>
          </ImageContainer>

          <ContentContainer form={campaign.form_type}>
            <StyledDiv>
              {!isMobile
                && (
                <BannerCard $isVisible={isVisible} onClick={handleClose}>
                  <CloseIcon />
                </BannerCard>
                )}

              <TextContentHeading>
                {campaign.heading}
              </TextContentHeading>
              <TextContentSubHeading>
                {campaign.sub_heading}
              </TextContentSubHeading>
            </StyledDiv>
            {
              campaign.form_type === 'Sign up Form'
              && (
                <FormContainer>
                  <CampaignForm
                    booking_category="second-opinion"
                    curefyDomain={false}
                    formName="FinderForm"
                    id="form"
                    modalSlide={modalSlide}
                    setModalSlide={setModalSlide}
                    campaignName={campaign.name}
                    currentUrl={consturl}
                  />
                </FormContainer>
              )
            }
            <StyledDiv>
              {
                campaign.form_type === 'Second Opinion Form'
                && (
                <RedirectContainer>
                  <RedirectButton
                    onClick={() => handleRedirect('secondOpinion')}
                  >
                    {t('SecondOpinion')}
                  </RedirectButton>
                    {t('SecondOpinionText')}
                </RedirectContainer>
                )
              }


              {
                campaign.form_type === 'Treatment Cost Flow Form'
                && (
                <RedirectContainer>
                  <RedirectButton
                    onClick={() => handleRedirect('TPF')}
                  >
                    {t('TreatmentPlan')}
                  </RedirectButton>
                  {t('TreatmentPlanText')}
                </RedirectContainer>
                )
              }
            </StyledDiv>
          </ContentContainer>
        </BannerContent>
      </BannerContainer>
    </>
  );
};


export default withTranslation('ContactPage')(PopupBanner);
